import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Router, Redirect } from 'react-router-dom'
import { history } from '../../utils';
import { PrivateRoute } from '../PrivateRoute';
import CssBaseline from '@material-ui/core/CssBaseline';
import { LoginPage } from '../LoginPage';
import { LeadsPage, EditLeadPage } from '../LeadsPage';
import { CouponPage } from '../CouponPage';
import { AllUsersPage } from '../AllUsersPage';
import { AuthActions } from '../../actions';

import moment from 'moment-timezone';
import 'moment/locale/he';
moment.locale('he');

class App extends Component {

    constructor(props) {
        super(props);

        this.props.dispatch(AuthActions.isAdminLoggedIn());
    }

    render () {
        const {auth} = this.props;

        return (
            // waiting for version 5 of https://www.npmjs.com/package/react-router-redux
            // and use react-router-redux for handle history
            // read more https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/blocked-updates.md
            <React.Fragment>
                <CssBaseline/>
                <Router history={history}>
                    <Switch>
                        <Route path='/login' component={LoginPage}/>
                        <PrivateRoute exact path="/users" loggedIn={auth.loggedIn} waitForProcess={auth.process}>
                            <AllUsersPage />
                        </PrivateRoute>
                        <PrivateRoute exact path="/coupons" loggedIn={auth.loggedIn} waitForProcess={auth.process}>
                            <CouponPage />
                        </PrivateRoute>
                        <PrivateRoute exact path="/leads" loggedIn={auth.loggedIn} waitForProcess={auth.process}>
                            <LeadsPage />
                        </PrivateRoute>
                        <PrivateRoute exact path="/leads/:leadID" loggedIn={auth.loggedIn} waitForProcess={auth.process}>
                            <EditLeadPage />
                        </PrivateRoute>
                        <PrivateRoute exact path="/" loggedIn={auth.loggedIn} waitForProcess={auth.process}>
                            <Redirect to="/users" />
                        </PrivateRoute>
                    </Switch>
                </Router>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.authReducer
    }
}

const AppWithRedux = connect(mapStateToProps)(App);

export {AppWithRedux as App};


// WEBPACK FOOTER //
// ./src/components/App/App.jsx